import React from "react";
import PropTypes from "prop-types";
import { SnackbarProvider } from "notistack";
import withTheme from "@material-ui/core/styles/withTheme";
import useMediaQuery from "@material-ui/core/useMediaQuery";

const OSSSnackbarProvider = ({ children, theme }) => {
  const dense = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <SnackbarProvider dense={dense} maxSnack={5}>
      {children}
    </SnackbarProvider>
  );
};

OSSSnackbarProvider.propTypes = {
  children: PropTypes.node
};

export default withTheme(OSSSnackbarProvider);
